// extracted by mini-css-extract-plugin
export default {"BasicCard":"BasicCard_BasicCard__qTYFp","card":"BasicCard_card__4IbQ1","title":"BasicCard_title__wrc0R","description":"BasicCard_description__5rD4f"};